import React from "react";
import {PageContainer, PageHeader, PageRow, Tab, TabContainer, TabContainerHeaderStyleType} from "@renta-apps/athenaeum-react-components";
import AuthorizedPage from "../../models/base/AuthorizedPage";
import {PageCacheProvider} from "@renta-apps/athenaeum-react-common";
import MassProductsMappingsData from "@/pages/MassProductsPage/MassProductsMappingsData/MassProductsMappingsData";
import MassProductsData from "@/pages/MassProductsPage/MassProductsData/MassProductsData";
import Localizer from "@/localization/Localizer";

interface IMassProductsPageProps  {
}

interface IMassProductsPageState {
}

export default class MassProductsPage extends AuthorizedPage<IMassProductsPageProps, IMassProductsPageState> {

    state: IMassProductsPageState = {};

    private readonly _massProductsDataRef: React.RefObject<MassProductsData> = React.createRef();
    private readonly _massProductsMappingsDataRef: React.RefObject<MassProductsMappingsData> = React.createRef();

    private async reloadMassProductsDataTabAsync(): Promise<void> {
        if (this._massProductsDataRef.current) {
            PageCacheProvider.clear();
            await this._massProductsDataRef.current!.reloadAsync();
        }
    }

    private async reloadMassProductsMappingsDataTabAsync(): Promise<void> {
        if (this._massProductsMappingsDataRef.current) {
            PageCacheProvider.clear();
            await this._massProductsMappingsDataRef.current!.reloadAsync();
        }
    }

    public getTitle(): string {
        return Localizer.massProductsPageTitle;
    }

    public render(): React.ReactNode {
        return (
            <PageContainer>

                <PageHeader title={Localizer.massProductsPageTitle}/>

                <PageRow>

                    <div className="col">

                        <TabContainer scale
                                      id="massProductsPageTabs"
                                      headerStyleType={TabContainerHeaderStyleType.Underline}>

                            <Tab id={"massProductsTab"} title={Localizer.massProductsTitle}>

                                <MassProductsData ref={this._massProductsDataRef}
                                                  reloadMassProductsMappings={() => this.reloadMassProductsMappingsDataTabAsync()}/>

                            </Tab>

                            <Tab id={"massProductsMappingsTab"} title={Localizer.massProductsTabMappings}>

                                <MassProductsMappingsData ref={this._massProductsMappingsDataRef}
                                                          reloadMassProductsData={() => this.reloadMassProductsDataTabAsync()}
                                />

                            </Tab>

                        </TabContainer>

                    </div>

                </PageRow>

            </PageContainer>
        );
    }
}